<template>
  <div>
    <div class="text-center">
      <v-btn
        @click="next"
        :disabled="loading"
        large
        depressed
        class="btn-amnistie font-weight-bold"
      >Suivant</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ["hideBack", "loading"],
  methods: {
    next() {
      this.$emit("next");
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style>
.hide {
  opacity: 0;
}
</style>